import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CostPerEmployeesComponent } from './cost-per-employees/cost-per-employees.component';
import { CostPerEmployeesAddComponent } from './cost-per-employees-add/cost-per-employees-add.component';
import { MatIconModule } from '@angular/material/icon';
import { TableModule } from '../../components/table/table.module';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';



@NgModule({
  declarations: [
    CostPerEmployeesComponent,
    CostPerEmployeesAddComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    TableModule,
    MatAccordion,
    MatExpansionModule,
    MatFormFieldModule,

    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatSelectModule
  ]
})
export class CostPerEmployeesModule { }
